import TextInput from "../../../../form/TextInput";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (hidden || []).indexOf("notenum") === -1 &&
        <div className="col-md-12">
            <TextInput
                name="notenum"
                label={labels.notenum || "Szállítólevél szám"}
                {...props.getProps("notenum")}
                value={props.getValue("notenum")}
                saveChanges={props.setFieldValue}
            />
        </div>;
}